// extracted by mini-css-extract-plugin
module.exports = {"button":"NavbarToggle_button__1H8Q_","opened":"NavbarToggle_opened__1MGWw"};